import {IN_MEMORY_CACHE_STORAGE, cacheable} from 'shared/cache';
import type {LoginView} from './types';
import type {AjaxService} from 'core/data-services/ajax.service';

export class LoginDataService {
    public static serviceName = 'loginDataService';

    public static readonly LOGIN_VIEW_ROUTE: string = 'login-view';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @cacheable(IN_MEMORY_CACHE_STORAGE, 'LOGIN_VIEW')
    public async getLoginView(): Promise<LoginView> {
        return this.ajaxService
            .createRequest(LoginDataService.LOGIN_VIEW_ROUTE)
            .get();
    }
}
